import { Outlet } from "react-router-dom";
import { ApplicationContextProvider } from "../context/app.context";
import "./app.component.scss";
import { Footer } from "./footer/footer";
import { DesktopHeader, MobileHeader } from "./header";

export const App = () => {
  return (
    <ApplicationContextProvider>
      <div className="app">
        <div className="d-none d-lg-block">
          <DesktopHeader />
        </div>
        <div className="d-block d-lg-none">
          <MobileHeader />
        </div>
        <main className="app-content">
          <Outlet />
        </main>
        <Footer />
      </div>
    </ApplicationContextProvider>
  );
};
